import { TOKEN_DECIMALS, PAYOUT_TIME } from '@r3l/common';

export function computePostPayout(postData, community) {
  if (!community || !postData || postData.parentPost) return null;
  if (postData.pagerank < community.currentShares / (community.postCount || 1)) {
    return 0;
  }
  postData.payoutShare =
    postData.pagerank / (community.topPostShares + postData.pagerank || 1);
  postData.payout = community.rewardFund * postData.payoutShare;
  return postData.payout / TOKEN_DECIMALS;
}

export function computeUserPayout(earning, community) {
  if (!community) return 0;
  if (earning.earned || earning.status === 'paidout') return earning.earned;

  if (earning.status === 'pending') {
    if (!earning?.postData) return 0;
    if (earning.totalPostShares === 0) return 0;
    let estimatedPayout = earning.estimatedPostPayout;
    if (estimatedPayout > 1e8) estimatedPayout /= TOKEN_DECIMALS;
    const payout = (estimatedPayout * earning.shares) / earning.totalPostShares;
    // discount by time
    const untilPayout = new Date(earning.payoutTime).getTime() - Date.now();
    const discount = (PAYOUT_TIME - Math.max(untilPayout, 0)) / PAYOUT_TIME;
    const avgRank = community.currentShares / (community.postCount || 1);
    // console.log(earning);
    const discountProbability = Math.min(
      1,
      Math.max(0, earning?.postData?.pagerank / avgRank - 1)
    );
    return payout * discount * discountProbability;
  }

  return 0;
}
